import React from 'react';
import {
  CircularProgress, Theme, Typography, useMediaQuery,
} from '@mui/material';
import { QueryRecords } from '../tasks/fields/task-link-field';
import Button from '../components/button';

export interface Props {
  data: QueryRecords,
  isLoading: boolean,
  pickerRecords: any,
  handlePageIncrement: () => void,
}

const RecordPickerPagination: React.FC<Props> = ({
  pickerRecords,
  data,
  isLoading,
  handlePageIncrement,
}) => {
  const isMobile = useMediaQuery((theme: Theme) => theme?.breakpoints.down('sm'));
  const paginationMessage = () => (`Showing ${pickerRecords.length} of ${data.total_count} results.`);
  const isShowingAllRecords = pickerRecords.length === data.total_count;
  const handleButtonSize = isMobile ? 'large' : 'small';
  return (isLoading ? (<CircularProgress />) : (
    <>
      <Typography>{paginationMessage()}</Typography>
      { !isShowingAllRecords && (
        <Button
          variant="outlined"
          size={handleButtonSize}
          color="secondary"
          onClick={handlePageIncrement}
          fullWidth={!!isMobile}
        >
          Load More Records
        </Button>
      )}
    </>
  ));
};

export default RecordPickerPagination;
